export default "\nfloat scalarize(in vec4 h) {\n    float isMissing = step(NIL, h.x);\n    return length((1.0 - isMissing) * h.xw) + isMissing * NIL;\n}\n";